import { Logger } from '../../generic/utils';
import { useEffect } from 'react';
import { wrapperIdentifier } from '../../wrappers/ApplicationWrapper/common';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}
const logic = wrapperBuilder.getCustomLogicRegisterInstance();

logic.setLogic(
  ({
    functions: { loadContributions },
    bindedContexts: { user },
    variablesHandler: {
      variablesSetter,
      variables: { contributions },
    },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        console.log('Loading dniDocuments');
        loadContributions(userId);
      } else if (!userId) {
        if (contributions) {
          variablesSetter('contributions')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
